module.exports = __webpack_public_path__ + "img/logoFotter.b5dae3fa.png";